import { bind, Component, h, tag } from "omi";

import { animateCss } from "@/globals/styles";
import { ProjectStatus } from "@/api";
import { tailwind } from "@/tailwind";

import { useCourses } from "./store/queries/courses.ts";
import { useRecommendedTopics } from "./store/queries/recommendedTopics.ts";
import { NavContainer } from "./components/navContainer.tsx";
import { NavLayout } from "./components/navLayout.tsx";
import { NavCategorySelection } from "./views/categorySelection";
import { NavCourseTrack } from "./views/courseTrack";
import { NavStore, NavView } from "./store";

@tag("nw-nav")
export class NWNav extends Component {
  static css = [tailwind, animateCss];
  private courses = useCourses();
  private recommendedTopics = useRecommendedTopics();

  async installed() {
    addEventListener("project_updated", this.handleProjectUpdate as EventListener);

    await Promise.all([NavStore.projectStore.fetch(), this.courses.fetch(), this.recommendedTopics.fetch()]);
    NavStore.hydrateSelectedTopics();
  }

  @bind
  private handleProjectUpdate(event: CustomEvent<{ projectId: string; status: ProjectStatus }>) {
    NavStore.updateProjectStatus(event.detail.projectId, event.detail.status);
  }

  @bind
  private renderNavState() {
    switch (NavStore.view.value) {
      case NavView.CATEGORY_SELECTION:
        return <NavCategorySelection></NavCategorySelection>;
      case NavView.TRACK_OVERVIEW:
        return <NavCourseTrack></NavCourseTrack>;
    }
  }

  render() {
    return (
      <NavContainer>
        <NavLayout>{this.renderNavState()}</NavLayout>
      </NavContainer>
    );
  }
}
